var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',_vm._g(_vm._b({attrs:{"value":_vm.value},on:{"change":function (e) { return _vm.inputChanged(e); }}},'vue-slider',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }